import store from '@/config/vuex'

export const DYNAMIC_YIELD = 'dynamic-yield'

export const DY_EVENTS = {
  addToCart: 'Add to Cart',
  addToCartMinicart: 'Add to Cart Minicart',
  ipo: 'IPO',
  login: 'Login',
  newsletterSubscription: 'Newsletter Subscription',
  purchase: 'Purchase',
  signup: 'Signup',
  syncCart: 'Sync cart',
}

const DY_EVENT_TYPES = {
  [DY_EVENTS.addToCart]: 'add-to-cart-v1',
  [DY_EVENTS.login]: 'login-v1',
  [DY_EVENTS.newsletterSubscription]: 'newsletter-subscription-v1',
  [DY_EVENTS.purchase]: 'purchase-v1',
  [DY_EVENTS.signup]: 'signup-v1',
  [DY_EVENTS.syncCart]: 'sync-cart-v1',
}
let debounceTimeout = null
let debouncedEvents = {}
const dyEventHandlers = {}

function sendDebouncedEventsToDy() {
  const events = Object.values(JSON.parse(JSON.stringify(debouncedEvents)))

  events.forEach(e => {
    if (window.DY?.API) window.DY.API('event', e)
    store.dispatch('dynamicYield/reportEventsToDy', [e]) // TODO: B2C-2451 - Remove this line
  })
  // TODO: B2C-2451 - Send multiple events in the same API call once DY fixed it on their end
  // store.dispatch('dynamicYield/reportEventsToDy', events)
  debouncedEvents = {}
}

function debounce(callback) {
  clearTimeout(debounceTimeout)
  debounceTimeout = setTimeout(callback, 100)
}

Object.values(DY_EVENTS).forEach(event => {
  dyEventHandlers[event] = (event, eventPayload) => {
    debouncedEvents[event] = debouncedEvents[event] || {
      name: event,
      properties: {
        ...(DY_EVENT_TYPES[event] ? { dyType: DY_EVENT_TYPES[event] } : {}),
        ...eventPayload,
      },
    }
    debounce(() => sendDebouncedEventsToDy(debouncedEvents))
  }
})
export default dyEventHandlers
